/* Память каркаса между перезагрузками страницы (раздел, голос «Озвучки», вкладка и прокрутка списка) — sessionStorage, как у шаблона (APP-SPEC §9).
   В серверном режиме ключ свой у каждого владельца: другой аккаунт в той же вкладке не получит чужой голос и раздел. */
export const SHELL_MEMORY_KEY = 'steos:bot:state';

export function shellMemoryKey(owner?: number | null): string {
  const id = owner ?? (window as unknown as { BotServerMe?: { user?: { id?: number } } }).BotServerMe?.user?.id;
  return id ? `${SHELL_MEMORY_KEY}:${id}` : SHELL_MEMORY_KEY;
}

export interface ShellMemory {
  sec?: string;
  tts?: { voice?: number | null; pst?: unknown; mem?: unknown };
}

export function readShellMemory(owner?: number | null): ShellMemory | null {
  try {
    return JSON.parse(sessionStorage.getItem(shellMemoryKey(owner)) || 'null') as ShellMemory | null;
  } catch {
    return null;
  }
}
